import * as React from "react";
import { BillingAccount } from "../../../schema/types/account";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { Button, Checkbox } from "antd";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { MARKETING_URL } from "../../../envVariables";

interface Props {
  account: BillingAccount;
}
export const AccountDetailSetupTou: React.FC<Props> = ({ account }) => {
  async function tryConfirmTou() {}

  return (
    <div className="mb-10">
      <div className="mb-4 text-2xl">Thank you for creating an account.</div>

      <div>
        <div className="flex items-center gap-2">
          <Checkbox />
          <CpLabel name={`skip`}>I accept the Control Plane Terms of Use</CpLabel>
        </div>
        <CpDescription>
          Click to read
          <a
            className={`mx-1 underline hover:underline focus:outline-none focus-visible:underline focus-visible:ring-2 color-link cursor-pointer`}
            target={"_blank"}
            href={`${MARKETING_URL}/terms-of-use`}
          >
            Terms of Use
          </a>
          of Control Plane Platform.
        </CpDescription>
      </div>
      <Button type={`primary`} className={"mt-6 action"} onClick={() => tryConfirmTou()}>
        Confirm
      </Button>
    </div>
  );
};
